import { initializeApp, getApps } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyAi8zo7wCKShs2CtkZknEOT5uEkB3uT-Oo',
  authDomain: 'iterogo.firebaseapp.com',
  projectId: 'iterogo',
  storageBucket: 'iterogo.firebasestorage.app',
  messagingSenderId: '903601697217',
  appId: '1:903601697217:web:0ba4702855aed15a9fff40',
  measurementId: 'G-WH6WJP6JBM',
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// App Check: protege Firestore/Storage/Auth contra abusos desde origenes
// no autorizados. Solo se inicializa en el navegador (typeof window) — en
// SSR / build de Next.js no aplica porque las rutas server-side usan
// firebase-admin (admin SDK saltea App Check por diseno).
if (typeof window !== 'undefined') {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(
        '6LfvY-osAAAAAHSoDN0DNW25LbsyiJaucTvQNAK4',
      ),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (e) {
    // initializeAppCheck lanza si se llama mas de una vez (HMR de Next.js).
    // Ignoramos para no romper recargas en desarrollo.
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[firebase] App Check init skipped:', e);
    }
  }
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// Cloud Functions desplegadas en europe-west3 (mismo region que los triggers).
export const functions = getFunctions(app, 'europe-west3');

export default app;
